// Typed browser handles for the destination-bound invitation lifecycle (xnf.3).

import type { FunctionReturnType } from "convex/server";

import { api } from "../../../../convex/_generated/api";

export const invitationListQuery = api.domain.invitations.listInvitations;
export const issueInvitationMutation = api.domain.invitations.issueInvitation;
export const resendInvitationMutation = api.domain.invitations.resendInvitation;
export const revokeInvitationMutation = api.domain.invitations.revokeInvitation;
export const acceptInvitationAction = api.domain.invitations.acceptInvitation;

export type InvitationListResult = FunctionReturnType<typeof invitationListQuery>;
export type AcceptInvitationResult = FunctionReturnType<typeof acceptInvitationAction>;
